import React, { useCallback, useEffect, useState } from "react";
import {
  Card,
  Typography,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Button,
  Box,
  useTheme,
  useMediaQuery,
  Divider,
} from "@mui/material";
import CardProducto from "../cardProducto";
import DialogNoContacto from "../DialogNoContacto";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ArchiveIcon from "@mui/icons-material/Archive";
import UnarchiveIcon from "@mui/icons-material/Unarchive";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { format } from "date-fns";
import { isMobile } from "react-device-detect";

interface DetallePedidosProps {
  pedidos: any;
  isAdmin: boolean;
  handleArchivarPedidos: (idPedido: number, archivar: boolean) => void;
}

const DetalleDesktop: React.FC<DetallePedidosProps> = ({
  pedidos,
  isAdmin,
  handleArchivarPedidos,
}) => {
  const openWhatsAppConversation = (
    nombreLocal: string,
    codigoPedido: string,
    telefono: number
  ) => {
    const text = `Hola, soy ${nombreLocal}, te contacto por el pedido ${codigoPedido} que hiciste por Avellaneda a un toque`;
    const url = `https://api.whatsapp.com/send?phone=${telefono}&text=${encodeURIComponent(
      text
    )}`;
    window.open(url, "_blank");
  };

  const [modalOpen, setModalOpen] = useState(false);
  const theme = useTheme();

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return format(date, "dd/MM/yyyy HH:mm");
  };

  return (
    <div>
      {pedidos.map((pedido: any, index: number) => (
        <div
          key={index}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <Typography
            variant="h5"
            style={{
              fontWeight: "bold",
              flexGrow: 1,
              marginBottom: "6px",
            }}
          >
            {`Detalles del Pedido ${pedido.codigo}`}
          </Typography>
          <Box
            key={index}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              flexGrow: 1,
            }}
          >
            {isAdmin && (
              <Typography
                variant="body1"
                sx={{ marginTop: "6px", marginBottom: "6px" }}
              >
                Local: {pedido.localNombre}
              </Typography>
            )}
            {isAdmin && <Divider sx={{ width: "100%" }} />}

            <Grid
              container
              rowSpacing={1}
              flexGrow={1}
              columnSpacing={{ xs: 1, sm: 2, md: 12 }}
              style={{ marginTop: "6px" }}
            >
              <Grid item xs={6}>
                <Typography
                  variant="body1"
                  sx={{ marginLeft: "auto", fontWeight: "bold" }}
                >
                  Enviado: {formatDate(pedido.fechaEnvio)}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  variant="body1"
                  sx={{ marginLeft: "auto", fontWeight: "bold" }}
                >
                  Total:{" "}
                  {pedido.totales.map((total: any, index: number) => (
                    <span key={index}>
                      {`${total.moneda.simbolo} ${new Intl.NumberFormat(
                        "es-AR"
                      ).format(parseFloat(total.total))}`}
                      {index < pedido.totales.length - 1 && " - "}
                    </span>
                  ))}
                </Typography>
              </Grid>

              {pedido.nombre && pedido.apellido && (
                <Grid item xs={6}>
                  <Typography variant="body1">
                    {`${pedido.nombre} ${pedido.apellido}`}
                  </Typography>
                </Grid>
              )}
              {pedido.compradorWhatsapp && (
                <Grid item xs={6}>
                  <Typography variant="body1" sx={{ marginLeft: "auto" }}>
                    {`(Tel termina en ${pedido.compradorWhatsapp.slice(-4)})`}
                  </Typography>
                </Grid>
              )}
              <Grid item xs={6}>
                <Typography variant="body1">
                  Retira: {pedido.pedidoTipoRetiro}
                </Typography>
              </Grid>
              {pedido.pais && (
                <Grid item xs={6}>
                  <Typography variant="body1">
                    {`País: ${pedido.pais}`}
                  </Typography>
                </Grid>
              )}
              {pedido.provincia && (
                <Grid item xs={6}>
                  <Typography variant="body1">
                    {`Provincia: ${pedido.provincia}`}
                  </Typography>
                </Grid>
              )}
              {pedido.codigoPostal && (
                <Grid item xs={6}>
                  <Typography variant="body1" sx={{ ml: "auto" }}>
                    {`Código Postal: ${pedido.codigoPostal}`}
                  </Typography>
                </Grid>
              )}
              {pedido.localidad && (
                <Grid item xs={12}>
                  <Typography variant="body1">
                    {`Localidad: ${pedido.localidad}`}
                  </Typography>
                </Grid>
              )}
              {pedido.direccion && (
                <Grid item xs={12}>
                  <Typography variant="body1" justifyContent="flex-start">
                    {`Dirección: ${pedido.direccion}${
                      pedido.pedidoTipoDireccion
                        ? ` (${pedido.pedidoTipoDireccion})`
                        : ""
                    }`}
                  </Typography>
                </Grid>
              )}
              {pedido.observaciones && (
                <Grid item xs={12}>
                  <Typography variant="body1" justifyContent="flex-start">
                    {`Observaciones: ${pedido.observaciones}`}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Box>
          <Box
            sx={{
              //maxHeight: 260,
              overflow: "auto",
              width: "100%",
              flexGrow: 1,
              marginBottom: "30px"
            }}
          >
            {pedido.productoList.map((producto: any) => (
              <CardProducto producto={producto} isMobile={isMobile} />
            ))}
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              gap: "10px",
              //width: "100%",
              marginTop: "20px",
              position: "absolute",
              bottom: 10,
              right: 22,
              left: 22,
            }}
          >
            <Button
              variant="contained"
              color="success"
              fullWidth
              style={{
                alignItems: "center",
                background: `linear-gradient(45deg, #55CF60, #27B53F)`,
                color: "#fff",
                padding: "10px 20px",
                fontSize: "16px",
                cursor: "pointer",
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
                flexBasis: !isAdmin ? "70%" : undefined,
              }}
              onClick={() =>
                pedido.compradorWhatsapp
                  ? openWhatsAppConversation(
                      pedido.localNombre,
                      pedido.codigo,
                      pedido.compradorWhatsapp
                    )
                  : setModalOpen(true)
              }
            >
              <WhatsAppIcon sx={{ marginRight: "8px", marginBottom: "4px" }} />
              Contactar al comprador
            </Button>
            {!isAdmin && (
              <Button
                onClick={() => {
                  pedido.vendedorArchivado
                    ? handleArchivarPedidos(pedido.idPedido, false)
                    : handleArchivarPedidos(pedido.idPedido, true);
                }}
                variant="contained"
                color="primary"
                sx={{
                  alignItems: "center",
                  padding: "10px 20px",
                  fontSize: "16px",
                  cursor: "pointer",
                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
                  flexBasis: !isAdmin ? "30%" : undefined,
                }}
              >
                {pedido.vendedorArchivado ? (
                  <UnarchiveIcon
                    sx={{
                      marginRight: "8px",
                      marginBottom: "4px",
                    }}
                  />
                ) : (
                  <ArchiveIcon
                    sx={{
                      marginRight: "8px",
                      marginBottom: "4px",
                    }}
                  />
                )}
                {pedido.vendedorArchivado ? "Desarchivar" : "Archivar"}
              </Button>
            )}
          </Box>
          <Dialog open={modalOpen} onClose={() => setModalOpen(false)}>
            <DialogContent>
              <DialogNoContacto codigoPedido={pedido.codigo} />
            </DialogContent>
            <DialogActions>
              <IconButton
                edge="end"
                //color="error"
                onClick={() => setModalOpen(false)}
                style={{
                  position: "absolute",
                  top: "8px",
                  right: "8px",
                  marginRight: "2px",
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogActions>
          </Dialog>
        </div>
      ))}
    </div>
  );
};

export default DetalleDesktop;
